// PlanosClientePlanosList.tsx
import React, { useCallback, useEffect, useState } from 'react';
import type { Plano } from './planoTypes';
import PlanoCard from './PlanoCard';
import { PlanosService } from '../estabelecimento/Service';
import { Layers, TriangleAlert } from 'lucide-react';

interface Props {
    estabId: string;
    onContratar: (plano: Plano) => void; // <– ESSA PROP PRECISA EXISTIR
    service: PlanosService;
}

const PlanosClientePlanosList: React.FC<Props> = ({
                                                      estabId,
                                                      onContratar,
                                                      service,
                                                  }) => {
    const [planos, setPlanos] = useState<Plano[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            setError(false);

            const { data } = await service.findAllCliente(estabId);
            setPlanos(data || []);
        } catch (e) {
            console.error(e);
            setError(true);
            setPlanos([]);
        } finally {
            setLoading(false);
        }
    }, [estabId, service]);

    useEffect(() => {
        load();
    }, [load]);

    if (loading) {
        return (
            <div className="space-y-2" aria-busy="true">
                {[0, 1, 2].map((item) => (
                    <div key={item} className="sf-skeleton h-24" />
                ))}
            </div>
        );
    }

    if (error) {
        return (
            <div className="sf-state">
                <TriangleAlert aria-hidden />
                <h2>Não foi possível carregar os planos</h2>
                <button type="button" className="btn btn-primary btn-sm" onClick={load}>
                    Tentar novamente
                </button>
            </div>
        );
    }

    if (!planos.length) {
        return (
            <div className="sf-state">
                <Layers aria-hidden />
                <h2>Nenhum plano disponível</h2>
                <p>Este estabelecimento ainda não oferece planos para contratação.</p>
            </div>
        );
    }

    return (
        <ul className="pla-list sf-group">
            {planos.map((plano) => (
                <PlanoCard key={plano._id} plano={plano} onContratar={onContratar} />
            ))}
        </ul>
    );
};

export default PlanosClientePlanosList;
